import React, { Component } from "react";

import { toast } from "react-toastify";
import {
  getKeywordsMeaning,
  geKeywords,
  //saveKeywordsMeaning,
  saveKeywords,
  saveKeywordsMeaningBulk

} from "../services/keywordsService";
import NavBar from "./navBar";
//import _ from "lodash";
import TextareaAutosize from "react-textarea-autosize";


class Keywords extends Component {
  state = {
    keys: [],
    keysmeaning: [],
    keyDesc: "",
    keysmeaning1: "",
    keysmeaning2: "",
    keysmeaning3: "",
    selectedKey: [],
    pcode: 0
  };

  async componentDidMount() {
    const { data } = await geKeywords();
    console.log(data);
    const str = this.props.user;
    let pcode = 0;


    if (str === "adib@salmustasharak.com") {
      pcode = 999;



    }
    else if (str === "bahaa@salmustasharak.com") {
      pcode = 777;
    }
    else if (str === "qutaiba@salmustasharak.com") {
      pcode = 777;
    }
    this.setState({ keys: data, pcode });
  }







  handleKeySelect = async key => {
    const { data } = await getKeywordsMeaning(key.id);
    console.log(data);
    this.setState({
      keyDesc: key.notes,
      keysmeaning: data,
      keysmeaning1: "",
      keysmeaning2: "",
      keysmeaning3: "",
      selectedKey: key

    });
  };

  handleChangeInput1 = ({ currentTarget: input }) => {

    this.setState({
      keysmeaning1: input.value
    });
  };
  handleChangeInput2 = ({ currentTarget: input }) => {


    this.setState({
      keysmeaning2: input.value
    });

  };
  handleChangeInput3 = ({ currentTarget: input }) => {

    this.setState({
      keysmeaning3: input.value
    });

  };
  handleSave = async () => {
    let key = this.state.selectedKey;
    if (this.state.keysmeaning1 !== "" &&
      this.state.keysmeaning2 !== "" &&
      this.state.keysmeaning3 !== ""
    ) {
      let keysmeaning = [{
        meaning: this.state.keysmeaning1,
        negative: this.state.selectedKey.negative,
        positive: !this.state.selectedKey.negative,
        Remarks: "",
        created: new Date(),
        modified: new Date(),
        keywords_id: this.state.selectedKey.id,
        user_id: 1,
        username: this.props.user,

      },
      {
        meaning: this.state.keysmeaning2,
        negative: this.state.selectedKey.negative,
        positive: !this.state.selectedKey.negative,
        Remarks: "",
        created: new Date(),
        modified: new Date(),
        keywords_id: this.state.selectedKey.id,
        user_id: 1,
        username: this.props.user,

      },
      {
        meaning: this.state.keysmeaning3,
        negative: this.state.selectedKey.negative,
        positive: !this.state.selectedKey.negative,
        Remarks: "",
        created: new Date(),
        modified: new Date(),
        keywords_id: this.state.selectedKey.id,
        user_id: 1,
        username: this.props.user,

      }]

      const str = this.props.user;


      await saveKeywordsMeaningBulk(keysmeaning);
      if (str === "adib@salmustasharak.com") {
        key.isadib = true;

      }
      else if (str === "qutaiba@salmustasharak.com") {
        key.isqutaiba = true;
      }
      await saveKeywords(key)
      const keys = this.state.keys.filter(x => x.id !== this.state.selectedKey.id);
      this.setState({
        keys,
        keysmeaning: [],
        keyDesc: "",
        keysmeaning1: "",
        keysmeaning2: "",
        keysmeaning3: "",
        selectedKey: []

      });

    } else {
      toast.error("يجب تفسير ٣ نماذج للرمز");
    }

  };


  getPagedData = () => {
    const {
      keys,
      keysmeaning,
      keyDesc,
      selectedKey

    } = this.state;



    return { keys, keysmeaning, selectedKey, keyDesc };
  };

  render() {
    const { length: count } = this.state.keys;

    const { user } = this.props;

    if (count === 0) return <p>There are no keywords  in the database.</p>;

    const { keys, keysmeaning, selectedKey, keyDesc } = this.getPagedData();




    return (
      <React.Fragment>
        <NavBar user={this.props.user} pcode={this.state.pcode} />
        <br></br>

        <div className="row">
          <div className="col-5 text-right">

            {keysmeaning.map(km => (
              <React.Fragment>
                <h5 className="text-primary">      {km.meaning}</h5> <hr></hr> <br></br>
              </React.Fragment>
            ))}
          </div>

          <div className="col-5 text-right">
            {selectedKey.length !== 0 ? <React.Fragment>
              <h2 className="text-danger text-right">      {selectedKey.keyword}</h2><hr></hr>
              <h4 className="text-info text-right">    {keyDesc}</h4>
              <TextareaAutosize
                minRows={4}
                className="form-control"
                style={{ direction: "rtl" }}
                rows={4}
                id="1"
                name="tafseer1"
                onChange={this.handleChangeInput1}
                placeholder="اكتب التفسير الأول"
              />
              <br></br>
              <TextareaAutosize
                minRows={4}
                className="form-control"
                style={{ direction: "rtl" }}
                rows={4}
                id="2"
                name="tafseer2"
                onChange={this.handleChangeInput2}

                placeholder="اكتب التفسير الثاني"

              />
              <br></br>
              <TextareaAutosize
                minRows={4}
                className="form-control"
                style={{ direction: "rtl" }}
                rows={4}
                id="3"
                name="tafseer3"
                onChange={this.handleChangeInput3}
                placeholder="اكتب التفسير الثالث"
              />
              <br>
              </br>
              <button
                onClick={this.handleSave}
                className="btn btn-primary"
              >
                حفظ
              </button>


            </React.Fragment> : <React.Fragment></React.Fragment>}
          </div>

          <div className="col-2 text-right">

            <div className="btn-group-vertical btn-group-lg btn-block p-2">
              {keys.map(keywords => (
                <button type="button"
                  onClick={() => this.handleKeySelect(keywords)}
                  key={keywords["id"]}
                  className={
                    selectedKey.id === keywords.id
                      ? "btn btn-primary btn-lg  active p-2"
                      : "btn btn-light  btn-lg   p-2"
                  }
                >
                  {keywords.keyword}
                </button>
              ))}
            </div>


          </div>
        </div>

      </React.Fragment>
    );
  }
}

export default Keywords;



// WEBPACK FOOTER //
// ./src/components/keywords.jsx